import React from "react";
import "./Dashboard_mainPage.css";
import { Link } from "react-router-dom";
import phone from "../../assets/images/phone.png";
import appointments from "../../assets/images/appointments.png";
import orders from "../../assets/images/orders.png";
import subscriptions from "../../assets/images/subscriptions.png";
import account from "../../assets/images/account.png";

const DashboardMainPage: React.FC = () => {
  return (
    <div className="dashboard-main">
      <div className="top-section">
        {/* Left Div */}
        <div className="left-div">
          <div className="left-content">
            <h2>Welcome back, Jasjeet</h2>
            <div className="action-buttons">
              {/* <button className="primary-btn">See a Provider</button>
              <button className="secondary-btn">Pre-Auth Status: Not Eligible</button> */}
            </div>
          </div>
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="118"
            height="124"
            viewBox="0 0 118 124"
            fill="none"
          >
            <path
              d="M6.22144 0C35.4981 1.30872 61.612 17.5626 69.2754 41.5091C76.749 64.8675 64.4243 88.5608 40.7238 101.231C23.1539 89.1334 9.88041 72.751 3.6913 53.4162C-2.16694 35.0979 -0.853213 16.659 6.22144 0ZM63.5193 94.5864C55.8657 96.1561 49.2046 99.2449 43.9059 103.342C64.5946 116.605 90.6891 124.153 118 123.998C117.771 122.65 117.445 121.298 117.017 119.947C110.993 101.118 87.0448 89.7644 63.5193 94.5825V94.5864Z"
              fill="#CEADD8"
              fillOpacity="0.1"
            />
          </svg>
        </div>

        {/* Right Div */}
        <div className="right-div">
          <div className="info-box">
            <img src={phone} alt="Phone" className="phone-icon" />

            <p>
              If you have questions, please
              
              text or call us at <strong>(877) 983-2210</strong>.
            </p>
          </div>
          <div className="separator-line"></div>
        </div>
      </div>

      {/* Cards Section */}
      <div className="cards-container">
        <div className="cards-wrapper">
          <div className="card orders">
            <div className="card-icon-wrapper">
              <div className="card-icon-bg">
                <img src={orders} alt="Orders" className="card-icon" />
              </div>
            </div>
            <h3>Orders</h3>
            <p>Lorem ipsum is simply dummy...</p>
          </div>
          <div className="card subscriptions">
            <div className="card-icon-wrapper">
              <div className="card-icon-bg">
                <img
                  src={subscriptions}
                  alt="Subscriptions"
                  className="card-icon"
                />
              </div>
            </div>
            <h3>Subscriptions</h3>
            <p>Lorem ipsum is simply dummy...</p>
          </div>
          <div className="card appointments">
            <div className="card-icon-wrapper">
              <div className="card-icon-bg">
                <img
                  src={appointments}
                  alt="Appointments"
                  className="card-icon"
                />
              </div>
            </div>
            <Link to="/dashboard/schedule_consultation">
              <h3>Appointments</h3>
              <p>Lorem ipsum is simply dummy...</p>
            </Link>          
          </div>
          <div className="card account-details">
            <div className="card-icon-wrapper">
              <div className="card-icon-bg">
                <img
                  src={account}
                  alt="Account Details"
                  className="card-icon"
                />
              </div>
            </div>
            <Link to="/dashboard/account">
              <h3>Account Details</h3>
              <p>Lorem ipsum is simply dummy...</p>
            </Link>
          </div>
        </div>
      </div>
    </div>
  );
};

export default DashboardMainPage;
